import styled from "styled-components";

const B1 = {
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: "#666666"
};

const B2 = {
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px",
  letterSpacing: "0.25px",
  color: "#D8D9D9"
};

const B3 = {
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: "#202020"
};

const B4 = {
  //button
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#212121"
};

const H1 = {
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "57px",
  lineHeight: "64px",
  color: "#FFFFFF",
  leadingTrim: "both",
  textEdge: "cap"
};

const H2 = {
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "32px",
  lineHeight: "44px",
  color: "#FFFFFF"
};

const H3 = {
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#FFFFFF",
  letterSpacing: "0.15px"
};

export const NavBar = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #00019d;
  border-bottom: 1px solid #000;
  ${H3} img {
    height: 40px;
  }

  .view-balance {
    cursor: pointer;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #ffffff;

  .or {
    ${B1}
    text-align: center;
    margin-bottom: 16px;
  }
`;

export const SectionContainer = styled.section`
  background-color: #00019d;
  margin-bottom: 1px;

  p {
    ${B1}
  }

  .title-bar {
    padding: 16px;
    display: flex;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;

    h2 {
      ${H2}
      color: white;
    }

    img {
      cursor: pointer;
    }
  }
  .content {
    background-color: white;
  }
`;

export const Welcome = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;

  h1 {
    ${H2}
    color:#212121;
  }
  p {
    ${B1}
  }
`;

export const Membership = styled.div`
  display: flex;
  flex-direction: column;

  .item {
    padding: 16px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .title {
      ${B4}
    }

    p {
      ${B1}
    }

    color: #212121;
  }
`;

export const ImageContainer = styled.div`
  padding-top: 0px; 
  padding-bottom: 0px; 
  margin: 0; 
  
  img {
    display: block; 
    max-width: 100%; 
    height: auto; 
  }
`;

export const ImagesContainer = styled.div`
  padding-top: 20px; 
  padding-bottom: 20px;
`;

export const Hospitality = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HospitalityItem = styled.div`
  border-radius: 4px;
  overflow: hidden;
  padding: 30px 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  background-image: url(${({ img }) => img});
  background-size: cover;
  background-repeat: no-repeat;

  .title {
    ${B4}
    color: white;
  }
`;

export const EventInformation = styled.div`
  padding: 16px;
  span {
    color: #00019d;
  }
`;

export const MyKeyfob = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .item {
    cursor: pointer;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0px 12px 16px -4px rgba(0, 0, 0, 0.08),
      0px 0px 6px -2px rgba(0, 0, 0, 0.05);

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;

    .details {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .title {
      ${B4}
    }
  }
`;

export const Help = styled.div`
  padding: 16px;
  a {
    ${B1}
    color: #00019D;
  }
`;

export const Download = styled.div`
  padding: 16px;
  a {
    ${B1}
    color: #000000;   // Changed
    text-decoration: underline; 
  }

  img {
      cursor: pointer;
      display: block;
      margin-bottom: 10px;
    }
  
.Download p:first-child {
  padding-bottom: 60px; 
}

.Download p:last-child {
  padding-top: 20px; 
  padding-bottom: 20px;
}

.enable-contactless {
      padding-bottom: 20px;
}

p.app-link {
  padding-bottom: 40px;
}
`;

export const Footer = styled.div`
  background: #00019d;
  border-top: 1px solid #000000;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;

  p {
    ${B4}
    margin-bottom: 8px;
    color: white;
  }

  img {
    height: auto;
    margin-bottom: 8px;
    cursor: pointer;
    width: auto;
  }


  .digiseq {
    height: 24px;
  }

  .sodexo {
    height: 64px;
  }
`;

export const InfoAlert = styled.div`
  max-width: 480px;
  position: absolute;
  background: rgba(9, 10, 15, 0.64);
  height: 100%;
  width: 100%;
  text-align: center;

  .inner-container {
    position: fixed;
    max-width: 360px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 32px 24px;
    background-color: white;
    border-radius: 8px;
    width: 90%;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .close-button {
      width: 32px;
      height: 32px;
      align-self: flex-end;
      cursor: pointer;
    }

    h2 {
      ${H2};
      color: #202020;
      margin-bottom: 8px;
    }

    p {
      ${B1}
      color: #202020;
      margin-bottom: 24px;
    }

    .top-icon {
      width: 75px;
      height: 75px;
      object-fit: contain;
      margin: auto;
    }
  }
`;
